import React from 'react'
import { CustomWindow } from './useVisualizeHelper'

/** Check for Visualize.js (JasperSoft client) on the window object */
const useCheckVisualizeLoaded = () => {
    const [isVisualizeLoaded, setIsVisualizeLoaded] = React.useState(false)

    React.useEffect(() => {
        const checkVisualize = () => {
            if ((window as CustomWindow).visualize) {
                setIsVisualizeLoaded(true)
            }
        }

        checkVisualize()

        if (!isVisualizeLoaded) {
            const intervalId = setInterval(checkVisualize, 500)

            // Cleanup on unmount
            return () => clearInterval(intervalId)
        }
        return
    }, [isVisualizeLoaded])

    return isVisualizeLoaded
}

export default useCheckVisualizeLoaded
